import RegionVenuesPage from './RegionVenuesPage';

export default RegionVenuesPage;

export { type Props } from './types';
export { generateBreadcrumbs } from './RegionVenuesPage';
